module.exports = __webpack_public_path__ + "img/mgh-kyoto-kawaramachi-jokyoji-sp.77a05aac.jpg";